var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.889 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.002,31.15c-3.069-6.668,1.525-14.914,9.8-14.857,0-.851-.081-1.717,.029-2.557,.071-.538,.32-1.152,.701-1.504,.161-.149,.944,.188,1.312,.474,2.485,1.923,4.942,3.881,7.392,5.848,.998,.802,1.049,1.507,.042,2.336-2.548,2.096-5.138,4.144-7.743,6.169-.792,.616-1.538,.274-1.689-.745-.098-.662-.068-1.349-.038-2.023,.034-.763-.229-1.059-1.044-1.008-3.993,.248-7.02,2.614-8.228,6.482-.133,.426-.32,.834-.534,1.384ZM14.087,13.452c0,.915-.001,1.545,0,2.176,.005,2.299,.005,1.864-1.827,1.876-2.697,.018-4.955,.992-6.782,2.962-1.747,1.884-2.718,4.994-2.15,6.925,2.11-3.485,5.168-5.257,9.259-5.286,1.105-.008,1.634,.29,1.501,1.475-.081,.721-.015,1.458-.015,2.467l7.913-6.287-7.899-6.308Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.fe8be39689becae7f85076a15839e05a.svg";
export { ForwardRef as ReactComponent };